export default __webpack_public_path__ + "static/media/arrow_down_home.42d0539d.svg";